// src/components/Card.jsx
//
// LSE-STYLE-NORMALIZE-1 (INC-05) — canonical Card component.
// Replaces S.card (deprecated) and the local CARD spread objects that
// proliferated across feature slices.
//
// ANATOMY
//   background: T.card  (white)
//   border:     1px solid T.border  (full perimeter, not bottom-only)
//   borderRadius: 8  (was 10 in S.card — see INC-05 in docs/style_guide.md)
//   boxShadow:  T.cardShadow  (was none in S.card)
//   padding:    20px default (override via style prop)
//
// USAGE
//   import { Card } from "../../components/Card.jsx";
//   <Card>content</Card>
//   <Card style={{ padding: 0, marginTop: 12 }}>content</Card>
//   <Card onClick={...} style={{ cursor: "pointer" }}>clickable</Card>
//
// EXPORTED CONSTANTS
//   CARD_STYLE — the raw style object for callers that cannot use the
//   component directly (e.g. divs with many competing style overrides).
//   Prefer the Card component; use CARD_STYLE only when necessary.

import React from "react";
import { T } from "../app/tokens.js";

export const CARD_STYLE = {
  background:   T.card,
  border:       `1px solid ${T.border}`,
  borderRadius: 8,
  boxShadow:    T.cardShadow,
};

export function Card({ children, style, ...props }) {
  return (
    <div style={{ ...CARD_STYLE, padding: 20, ...style }} {...props}>
      {children}
    </div>
  );
}
